module.exports = __webpack_public_path__ + "static/media/banner1.b58e0109.svg";